import styled from "styled-components"

const InputIconWrapperBegin = styled<any, "div">("div")`
  transform: none;
  opacity: 1;
  position: absolute;
  top: 8px;
  left: 8px;
  width: 20x;
  margin: 5px;
  z-index: 1;
  overflow: hidden;
  box-sizing: border-box;
`

export default InputIconWrapperBegin
